import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { RxEligibilityResponse } from "../types";

export type {
  PatientDemographicsEligibility,
  RxEligibilityResponse,
} from "../types";

export const useRxEligibility = ({
  patientId,
  enabled,
}: {
  patientId: string;
  enabled: boolean;
}) =>
  useApi<RxEligibilityResponse>({
    queryOptions: {
      enabled: Boolean(patientId && enabled),
      queryFn: async () => {
        const response = await axiosInstance.get<RxEligibilityResponse>(
          "/rx/eligibility/",
          { params: { patient_id: patientId } },
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.Eligibility.DEFAULT(patientId),
    },
  });
